import { NavLink, Navigate, Outlet } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { DESK } from "../../constants/testIds";
import { useDeskData } from "../../contexts/DeskDataContext";
import { fadeIn } from "../../lib/motion";

const TABS = [
  { key: "dashboard", label: "Dashboard", path: "/desk/mgr" },
  { key: "expenses", label: "Expenses", path: "/desk/mgr/expenses" },
  { key: "payouts", label: "Payouts", path: "/desk/mgr/payouts" },
  { key: "refunds", label: "Refunds", path: "/desk/mgr/refunds" },
  { key: "day-end", label: "Day-End", path: "/desk/mgr/day-end" },
  { key: "roster", label: "Roster", path: "/desk/mgr/roster" },
  { key: "performance", label: "Performance", path: "/desk/mgr/performance" },
  { key: "offers", label: "Offers", path: "/desk/mgr/offers" },
  { key: "stock", label: "Stock", path: "/desk/mgr/stock" },
  { key: "governance", label: "Governance", path: "/desk/mgr/governance" },
];

// UX-FD-03 §0/§3: the Manager tier is "reviewed, not raced through" — a touch more breathing
// room than the raw FD-01/02 workhorse tabs (taller tab bar, roomier gap), still lighter than
// the full Owner Cockpit. A second-level tab strip nested INSIDE the Desk shell's own "Manager"
// nav item, not a separate top-level shell — reuses DeskShell/DeskDataContext untouched.
export function MgrLayout() {
  const reducedMotion = useReducedMotion();
  const { me } = useDeskData();
  // Defense-in-depth (testing_agent_v4, iteration 26): the "Manager" nav item is genuinely
  // absent for FD in DeskShell, but that alone doesn't stop a direct URL visit — redirect any
  // non-Manager session here too, mirroring the nav item's own role gate. The backend already
  // 403s every underlying call regardless, so this closes the last UI-level exposure only.
  if (me && me.role !== "front_of_house_mgr") return <Navigate to="/desk/today" replace />;
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-1 overflow-x-auto rounded-[12px] p-1.5" style={{ background: "#EBE9E2" }}>
        {TABS.map((t) => (
          <NavLink
            key={t.key}
            to={t.path}
            end={t.key === "dashboard"}
            data-testid={DESK.mgrTab(t.key)}
            className={({ isActive }) =>
              `px-3.5 py-2 rounded-[9px] text-sm font-semibold shrink-0 transition-colors ${isActive ? "bg-white shadow-sm text-[#141416]" : "text-[#68686E] hover:text-[#141416]"}`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </div>
      <motion.div {...fadeIn(reducedMotion)}>
        <Outlet />
      </motion.div>
    </div>
  );
}
